var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 59,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M4 1h61v46H4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.629,
    cy: 18.906,
    r: 5.906,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 36.75c0-1.413.276-2.812.81-4.117a10.767 10.767 0 012.304-3.49 10.624 10.624 0 013.45-2.332 10.522 10.522 0 018.135 0c1.29.54 2.462 1.333 3.45 2.332.986.999 1.77 2.185 2.303 3.49.535 1.305.81 2.703.81 4.116v3.417H24V36.75z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8h61"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 33.55L61.728 27 74 33.55c0 6.193-.204 12.288-2.271 17.11-1.722 4.016-9.092 7.34-10 7.34-.91 0-8.124-3.059-10.002-7.34C49.53 45.65 49.001 38.965 49 33.55z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 37.5L66 46m0-8.5L57.5 46m4.228-19L49 33.55c.001 5.415.53 12.1 2.727 17.11C53.605 54.941 60.82 58 61.728 58c.91 0 8.279-3.324 10-7.34C73.797 45.838 74 39.743 74 33.55L61.728 27z",
    stroke: "#D66",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgVerifFailed;